import Login from "./views/login/login";
import ForgotPassword from "./views/login/forgotPassword";
import _ from "lodash";
import MobileLogin from "./views/login/mobileLogin";
import AdminDashboard from "./views/dashboard/adminDashboard";
import WelcomeDashboard from "./views/welcome/welcome";
import VendorList from "./views/vendorList/vendorList";
import { UserObj } from "./services/localStarage";
import ExistingVendorList from "./views/vendorList/existingVendorList";
import VendorDetails from "./views/vendorList/vendorDetails";
import ControlPanel from "./views/configuration/controlPanel";
import EmployeeCreation from "./views/configuration/employeeCreation";
import EmailLogin from "./views/login/emailLogin";
import VendorDashboard from "./views/dashboard/vandorDashboard";
import VendorWelcome from "./views/welcome/vendorWelcome";
import Onboardingstatus from "./views/onboarding/onboardingstatus";
import CategoryManagement from "./categoryManagament/categoryManagement";
import StatusMapping from "./statusManagement/statusMapping";
import PurchaseOrder from "./views/buyerPurchaseOrder/purchaseOrder";
import Profile from "./views/profileVendor/profile";
import PoDetail from "./views/buyerPurchaseOrder/poDetail";
import AsnVendorList from "./views/asnVendor/asnVendorList";
import AsnDetail from "./views/asnVendor/asnDetail";
import QcListing from "./views/vendorQc/qcListing";
import QcDetails from "./views/vendorQc/qcDetails";
import LrVendor from "./views/vendorLr/lrVendor";
import VendorOnboardingForm from "./views/onboarding/vendorOnboardingForm";
import BuyerOnboardingForm from "./views/onboarding/buyerOnboardingForm";
import StepAssignee from "./views/configuration/stepAssignee";
import LogsApi from "./views/apiLogs/logsApi";
import LrListing from "./views/vendorLr/lrListing";
import DeatilLr from "./views/vendorLr/deatilLr";
import GateEntryListing from "./views/gateEntry/gateEntryListing";
import GateEntryDetail from "./views/gateEntry/gateEntryDetail";
import ProjectListing from "./views/projectManagerScreens/projectListing";
import ProjectDetail from "./views/projectManagerScreens/projectDetail";
import PackageDetail from "./views/projectManagerScreens/packageDetail";
import PackageListing from "./views/projectManagerScreens/packageListing";
import ListingRFQ from "./views/biddingEngineering/listingRFQ";
import RfqDetail from "./views/biddingEngineering/rfqDetail";
import EvaluationTechnical from "./views/biddingEngineering/evaluationTechnical";
import PackageCreationForm from "./views/projectManagerScreens/packageCreationForm";
import RfqCreactionForm from "./views/biddingEngineering/rfqCreactionForm";
import EvaluationCommercial from "./views/biddingEngineering/evaluationCommercial";
import CommercialComparison from "./views/biddingEngineering/commercialComparison";
import InitiateEvaluation from "./views/biddingEngineering/initiateEvaluation";
import ListingPurchase from "./views/purchageInvoice/listingPurchase";
import ListingAccount from "./views/accountLedger/listingAccount";
import CndnListing from "./views/vendorCnListing/cndnListing";
import VendorCndnDetail from "./views/vendorCnListing/vendorCndnDetail";
import AccountDetail from "./views/accountLedger/accountDetail";
import PurchaseDetail from "./views/purchageInvoice/purchaseDetail";
import ListingGrn from "./views/grn/listingGrn";
import GrnDetail from "./views/grn/grnDetail";
import ComparisonroundoneCommercial from "./views/biddingEngineering/comparisonroundoneCommercial";
import VendorEvaluation from "./views/evaluationVendorBuyer/vendorEvaluation";
import EvaluationPerfomonaceRatting from "./views/evaluationVendorBuyer/evaluationPerfomonaceRatting";
import PodetailService from "./views/buyerPurchaseOrder/podetailService";
import QcCreationForm from "./views/vendorQc/qcCreationForm";
import MasterData from "./views/dateMaster/masterData";
import ModificationList from "./views/poModification/modificationList";
import PoModificationDetail from "./views/poModification/poModificationDetail";
import PoModificationCreation from "./views/poModification/poModificationCreation";
import PoPriceModificationCreation from "./views/poModification/poPriceModificationCreation";
import PoQtyModificationCreation from "./views/poModification/poQtyModificationCreation";
import DataanalysisReport from "./views/analysisReport/dataanalysisReport";
import ApprovalNFA from "./views/nfaApproval/approvalNFA";
import Marterial from "./views/dateMaster/marterial";
import MasterdataServices from "./views/dateMaster/masterdataServices";
const userRole = UserObj ? UserObj?.role?.name : "";
const modulePermissions = UserObj ? UserObj?.role?.modulePermissions : [];
const authLoginArr = [
  {
    path: "/login",
    name: "Login",
    redirect: true,
    component: Login,
    layout: "/auth",
    configName: "LOGIN",
    isSubRoute: false,
  },
  {
    path: "/email-login",
    name: "Email Login",
    redirect: true,
    component: EmailLogin,
    layout: "/auth",
    configName: "Email Login",
    isSubRoute: false,
  },
  {
    path: "/forgot-password",
    name: "Forgot Password",
    redirect: true,
    component: ForgotPassword,
    layout: "/auth",
    configName: "FORGOT_PASSWORD",
    isSubRoute: false,
  },
  {
    path: "/mobile-auth",
    name: "Mobile Login",
    redirect: true,
    component: MobileLogin,
    layout: "/auth",
    configName: "Mobile_Login",
    isSubRoute: false,
  }
];

const loginPageRoutes = [

  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "fas fa-tachometer-alt",
    miniName: "D",
    component:
      UserObj?.role?.name == "VENDOR" ? VendorDashboard : AdminDashboard,
    layout: "/admin",
    redirect: false,
    isSidebar: true,
    isSubRoute: false,
    configName: "DASHBOARD",
  },

  {
    path: "/onboarding-from",
    name: "Onboarding Form",
    icon: "fas fa-tachometer-alt",
    miniName: "O",
    component: VendorOnboardingForm,
    layout: "/admin",
    redirect: true,
    isSidebar: false,
    isSubRoute: false,
    configName: "INITIATE_ONBOARDING",
  },
  {
    path: "/edit-onboarding-from/:id",
    name: "Edit Onboarding Form",
    icon: "fas fa-tachometer-alt",
    miniName: "O",
    component: BuyerOnboardingForm,
    layout: "/admin",
    redirect: true,
    isSidebar: false,
    isSubRoute: false,
    configName: "REGULAR_NEW_VENDOR_LISTING",
  },

  {
    path: "/onboarding-form-status",
    name: "Onboarding Status",
    icon: "fas fa-tachometer-alt",
    miniName: "O",
    component: Onboardingstatus,
    layout: "/admin",
    redirect: true,
    isSidebar: false,
    isSubRoute: false,
    configName: "VIEW_PROGRESS",
  },
  {
    path: "/welcome",
    name: "Welcome",
    icon: "fas fa-tachometer-alt",
    miniName: "D",
    component:
      UserObj?.role?.name == "VENDOR" ? VendorWelcome : WelcomeDashboard,
    layout: "/admin",
    redirect: true,
    isSidebar: false,
    isSubRoute: false,
    configName: "INITIATE_ONBOARDING",
  },
  {
    path: "/welcome-onboard",
    name: "Welcome",
    icon: "fas fa-tachometer-alt",
    miniName: "D",
    component: WelcomeDashboard,
    layout: "/admin",
    redirect: true,
    isSidebar: true,
    isSubRoute: true,
    configName: "ONBOARDING_COMPLETE",
  },
  {
    collapse: true,
    name: "Vendor List",
    icon: "fas fa-tachometer-alt",
    miniName: "V",
    configName: "VENDOR_LIST",
    redirect: false,
    views: [
      {
        path: "/vendor-list-existing",
        name: "Existing Vendor List",
        icon: "fas fa-tachometer-alt",
        miniName: "V",
        component: ExistingVendorList,
        layout: "/admin",
        isSidebar: true,
        redirect: false,
        isSubRoute: true,
        configName: "EXISTING_VENDOR_LISTING",
      },
      {
        path: "/vendor-list",
        name: "Vendor List",
        icon: "fas fa-tachometer-alt",
        miniName: "V",
        component: VendorList,
        layout: "/admin",
        isSidebar: true,
        redirect: true,
        isSubRoute: true,
        configName: "REGULAR_NEW_VENDOR_LISTING",
      },
    ],
  },

  {
    path: "/vendor-list-details/:id",
    name: "Vendor Details",
    icon: "fas fa-tachometer-alt",
    miniName: "V",
    component: VendorDetails,
    layout: "/admin",
    isSidebar: true,
    redirect: true,
    isSubRoute: true,
    configName: "REGULAR_NEW_VENDOR_LISTING",
  },

  {
    collapse: true,
    name: "Configuration",
    icon: "fas fa-tachometer-alt",
    miniName: "C",
    configName: "CONFIGURATION",
    redirect: false,
    views: [
      {
        path: "/configuration-employee-creation",
        name: "Employee Management",
        icon: "fas fa-tachometer-alt",
        miniName: "C",
        component: EmployeeCreation,
        layout: "/admin",
        redirect: true,
        isSidebar: true,
        isSubRoute: true,
        configName: "EMPLOYEE_CREATION",
      },
      {
        path: "/configuration-control-panel",
        name: "Control Panel",
        icon: "fas fa-tachometer-alt",
        miniName: "C",
        component: ControlPanel,
        layout: "/admin",
        redirect: false,
        isSidebar: true,
        isSubRoute: true,
        configName: "CONTROL_PANEL",
      },
      {
        component: CategoryManagement,
        path: "/category-management",
        name: " Category Management",
        icon: "fas fa-tachometer-alt",
        miniName: "V",
        layout: "/admin",
        isSidebar: true,
        redirect: true,
        isSubRoute: true,
        configName: "CATEGORY_MANAGEMENT",
      },
      {
        component: StatusMapping,
        path: "/status-&-mapping-management",
        name: "Status & Mapping Management",
        icon: "fas fa-tachometer-alt",
        miniName: "V",
        layout: "/admin",
        isSidebar: true,
        redirect: true,
        isSubRoute: true,
        configName: "STATUS_AND_MAPPING_MANAGEMENT",
      },
      {
        component: StepAssignee,
        path: "/configuration-step-assignee",
        name: "Step Assignee",
        icon: "fas fa-tachometer-alt",
        miniName: "V",
        layout: "/admin",
        isSidebar: true,
        redirect: true,
        isSubRoute: true,
        configName: "STEP_ASSIGNEE",
      },
    ],
  },


  {
    component: LogsApi,
    path: "/admin-apilogs",
    name: "API Logs",
    icon: "fas fa-tachometer-alt",
    miniName: "A",
    layout: "/admin",
    isSidebar: true,
    redirect: false,
    isSubRoute: true,
    configName: "API_LOG",
  },
  {
    component: PurchaseOrder,
    path: "/buyer-purchaseOrder",
    name: "Purchase Order",
    icon: "fas fa-tachometer-alt",
    miniName: "P",
    layout: "/admin",
    isSidebar: true,
    redirect: false,
    isSubRoute: true,
    configName: "PURCHASE_ORDER_LISTING",
  },
  {
    component: AsnVendorList,
    path: "/vendor-asnVendorList",
    name: "ASN Listing",
    icon: "fas fa-tachometer-alt",
    miniName: "V",
    layout: "/admin",
    isSidebar: true,
    redirect: false,
    isSubRoute: true,
    configName: "ASN_LISTING",
  },
  {
    component: QcListing,
    path: "/vendor-qc-listing",
    name: "QC Listing",
    icon: "fas fa-tachometer-alt",
    miniName: "Q",
    layout: "/admin",
    isSidebar: true,
    redirect: false,
    isSubRoute: true,
    configName: "QC_LISTING",
  },
  {
    component: LrVendor,
    path: "/vendor-LR-Creation",
    name: "Vendor LR",
    icon: "fas fa-tachometer-alt",
    miniName: "V",
    layout: "/admin",
    isSidebar: true,
    redirect: true,
    isSubRoute: true,
    configName: "CREATE_LR",
  },
  {
    component: LrListing,
    path: "/vendor-Listing-Lr",
    name: "LR Listing",
    icon: "fas fa-tachometer-alt",
    miniName: "V",
    layout: "/admin",
    isSidebar: true,
    redirect: false,
    isSubRoute: false,
    configName: "LR_LISTING",
  },
  {
    component: PackageCreationForm,
    path: "/Package-Creation-Form",
    name: "Package-Creation",
    icon: "fas fa-tachometer-alt",
    miniName: "V",
    layout: "/admin",
    isSidebar: true,
    redirect: true,
    isSubRoute: true,
    configName: "CREATE_PACKAGE",
  },
  {
    component: DeatilLr,
    path: "/vendor-LR-Deatil/:id",
    name: "Vendor LR",
    icon: "fas fa-tachometer-alt",
    miniName: "V",
    layout: "/admin",
    isSidebar: true,
    redirect: true,
    isSubRoute: true,
    configName: "LR_DETAIL",
  },
  {
    component: GateEntryListing,
    path: "/vendor-Gate-Entry-Listing",
    name: "Gate Entry Listing",
    icon: "fas fa-tachometer-alt",
    miniName: "V",
    layout: "/admin",
    isSidebar: true,
    redirect: false,
    isSubRoute: false,
    configName: "GATE_ENTRY_LISTING",
  },
  {
    component: ListingGrn,
    path: "/vendor-grn-listing",
    name: "GRN Listing",
    icon: "fas fa-tachometer-alt",
    miniName: "V",
    layout: "/admin",
    isSidebar: true,
    redirect: false,
    isSubRoute: false,
    configName: "GRN_LISTING",
  },

  {
    component: GateEntryDetail,
    path: "/vendor-Gate-Entry-Detail/:id",
    name: "Gate Entry Listing",
    icon: "fas fa-tachometer-alt",
    miniName: "V",
    layout: "/admin",
    isSidebar: true,
    redirect: true,
    isSubRoute: true,
    configName: "GATE_ENTRY_LISTING",
  },
  {
    component: ListingPurchase,
    path: "/vendor-Purchase-Invoice-Listing",
    name: "Purchase Invoice ",
    icon: "fas fa-tachometer-alt",
    miniName: "V",
    layout: "/admin",
    isSidebar: true,
    redirect: false,
    isSubRoute: false,
    configName: "PURCHASE_INVOICE_LISTING",
  },
  {
    component: ListingAccount,
    path: "/vendor-Account-Ledger-Listing",
    name: "Account Ledger",
    icon: "fas fa-tachometer-alt",
    miniName: "V",
    layout: "/admin",
    isSidebar: true,
    redirect: false,
    isSubRoute: false,
    configName: "ACCOUNT_LEDGER_LISTING",
  },
  {
    component: CndnListing,
    path: "/vendor-CNDN-Listing",
    name: "CN/DN Listing",
    icon: "fas fa-tachometer-alt",
    miniName: "V",
    layout: "/admin",
    isSidebar: true,
    redirect: false,
    isSubRoute: false,
    configName: "CN_DN_LISTING",
  },
  {
    component: DataanalysisReport,
    path: "/buyer-data-analysis-report",
    name: "Delay Analysis Report",
    icon: "fas fa-tachometer-alt",
    miniName: "V",
    layout: "/admin",
    isSidebar: true,
    redirect: false,
    isSubRoute: false,
    configName: "DELAY_ANALYSIS_REPORT_LISTING",
  },
  {
    component: ModificationList,
    path: "/po-modification-list",
    name: "PO Modification Request",
    icon: "fas fa-tachometer-alt",
    miniName: "P",
    layout: "/admin",
    isSidebar: true,
    redirect: false,
    isSubRoute: false,
    configName: "PO_REQUEST_LISTING",
  },
  {
    component: PoQtyModificationCreation,
    path: "/po-qty-modification-creation",
    name: "PO QTY Modification",
    icon: "fas fa-tachometer-alt",
    miniName: "V",
    layout: "/admin",
    isSidebar: true,
    redirect: true,
    isSubRoute: true,
    configName: "CREATE_QUANTITY_MOD_REQ",
  },
  {
    component: PoModificationDetail,
    path: "/po-modification-detail/:id",
    name: "PO QTY Modification",
    icon: "fas fa-tachometer-alt",
    miniName: "V",
    layout: "/admin",
    isSidebar: true,
    redirect: true,
    isSubRoute: true,
    configName: "PO_REQUEST_LISTING",
  },
  {
    component: PoPriceModificationCreation,
    path: "/po-price-modification-creation",
    name: "PO Price Modification",
    icon: "fas fa-tachometer-alt",
    miniName: "V",
    layout: "/admin",
    isSidebar: true,
    redirect: true,
    isSubRoute: true,
    configName: "CREATE_PRICE_MOD_REQ",
  },
  
  {
    collapse: true,
    name: "Master Data",
    icon: "fas fa-tachometer-alt",
    miniName: "V",
    configName: "MASTER_DATA",
    redirect: false,
    views: [
      {
        path: "/master-material-data",
        name: "Material",
        icon: "fas fa-tachometer-alt",
        miniName: "V",
        component: Marterial,
        layout: "/admin",
        isSidebar: true,
        redirect: false,
        isSubRoute: true,
        configName: "MATERIAL_LISTING",
      },
      {
        path: "/master-service-data",
        name: "Service",
        icon: "fas fa-tachometer-alt",
        miniName: "V",
        component: MasterdataServices,
        layout: "/admin",
        isSidebar: true,
        redirect: true,
        isSubRoute: true,
        configName: "SERVICE_LISTING",
      },
    ],
  },
  // {
  //   component: MasterData,
  //   path: "/buyer-master-data",
  //   name: "Master Data",
  //   icon: "fas fa-tachometer-alt",
  //   miniName: "V",
  //   layout: "/admin",
  //   isSidebar: true,
  //   redirect: false,
  //   isSubRoute: false,
  //   configName: "CN_DN_LISTING",
  // },
  {
    component: VendorEvaluation,
    path: "/buyer_vendor_evaluation",
    name: "Vendor Evaluation",
    icon: "fas fa-tachometer-alt",
    miniName: "V",
    layout: "/admin",
    isSidebar: true,
    redirect: false,
    isSubRoute: false,
    configName: "VENDOR_EVALUATION_FEATURE",
  },

  {
    component: ProjectListing,
    path: "/Project-Manager-Listing",
    name: "Project Listing",
    icon: "fas fa-tachometer-alt",
    miniName: "V",
    layout: "/admin",
    isSidebar: true,
    redirect: false,
    isSubRoute: false,
    configName: "PROJECT_LISTING",
  },
  {
    component: PackageListing,
    path: "/Project-Manager-Packages-Listing",
    name: "Package Listing",
    icon: "fas fa-tachometer-alt",
    miniName: "V",
    layout: "/admin",
    isSidebar: true,
    redirect: false,
    isSubRoute: false,
    configName: "PACKAGE_LISTING",
  },
  {
    component: ListingRFQ,
    path: "/Engineering-Bidding-Rfq-Listing",
    name: "RFQ Listing",
    icon: "fas fa-tachometer-alt",
    miniName: "V",
    layout: "/admin",
    isSidebar: true,
    redirect: false,
    isSubRoute: false,
    configName: "RFQ_LISTING",
  },

  {
    component: ProjectDetail,
    path: "/Project-Manager-Detail/:id",
    name: "Project Detail",
    icon: "fas fa-tachometer-alt",
    miniName: "V",
    layout: "/admin",
    isSidebar: true,
    redirect: true,
    isSubRoute: true,
    configName: "VIEW_PROJECT_DETAILS",
  },
  {
    component: EvaluationPerfomonaceRatting,
    path: "/hod_vendor_performance_evaluation/:id",
    name: "Vendor Perfomance Evaluation",
    icon: "fas fa-tachometer-alt",
    miniName: "V",
    layout: "/admin",
    isSidebar: true,
    redirect: true,
    isSubRoute: true,
    configName: "VENDOR_EVALUATION_FEATURE",
  },

  {
    path: "/Vendor-Purchase-Detail/:id",
    name: "Purchase Detail",
    icon: "fas fa-tachometer-alt",
    miniName: "P",
    component: PurchaseDetail,
    layout: "/admin",
    isSidebar: true,
    redirect: true,
    isSubRoute: true,
    configName: "PURCHASE_INVOICE_LISTING",
  },
  {
    path: "/Vendor-Account-Detail",
    name: "Account Detail",
    icon: "fas fa-tachometer-alt",
    miniName: "P",
    component: AccountDetail,
    layout: "/admin",
    isSidebar: true,
    redirect: true,
    isSubRoute: true,
    configName: "ACCOUNT_LEDGER_LISTING",
  },
  {
    path: "/Vendor-CNDN-Detail",
    name: "CNDN Detail",
    icon: "fas fa-tachometer-alt",
    miniName: "P",
    component: VendorCndnDetail,
    layout: "/admin",
    isSidebar: true,
    redirect: true,
    isSubRoute: true,
    configName: "CN_DN_LISTING",
  },
  {
    path: "/nfa-approval/:id",
    name: "NFA Approval",
    icon: "fas fa-tachometer-alt",
    miniName: "P",
    component: ApprovalNFA,
    layout: "/admin",
    isSidebar: true,
    redirect: true,
    isSubRoute: true,
    configName: "RFQ_LISTING",
  },
  {
    component: PackageDetail,
    path: "/Project-Manager-Package-Detail/:id",
    name: "Package Detail",
    icon: "fas fa-tachometer-alt",
    miniName: "V",
    layout: "/admin",
    isSidebar: true,
    redirect: true,
    isSubRoute: true,
    configName: "PACKAGE_DETAILS",
  },
  {
    component: RfqDetail,
    path: "/Engineering-Bidding-Rfq-detail",
    name: "Rfq Detail",
    icon: "fas fa-tachometer-alt",
    miniName: "V",
    layout: "/admin",
    isSidebar: true,
    redirect: true,
    isSubRoute: true,
    configName: "RfqDetail",
  },
  {
    component: RfqCreactionForm,
    path: "/Buyer-Bidding-Rfq-Creaction-Form/:id",
    name: "Rfq Creaction From",
    icon: "fas fa-tachometer-alt",
    miniName: "V",
    layout: "/admin",
    isSidebar: true,
    redirect: true,
    isSubRoute: true,
    configName: "RFQ_LISTING",
  },
  {
    component: EvaluationTechnical,
    path: "/Engineering-Bidding-Technical-Evaluation/:id",
    name: "Technical Evaluation",
    icon: "fas fa-tachometer-alt",
    miniName: "V",
    layout: "/admin",
    isSidebar: true,
    redirect: true,
    isSubRoute: true,
    configName: "TECHNICAL_EVALUATION",
  },
  {
    component: EvaluationCommercial,
    path: "/Buyer-Bidding-Commercial-Evaluation/:id",
    name: "Commercial Evaluation",
    icon: "fas fa-tachometer-alt",
    miniName: "V",
    layout: "/admin",
    isSidebar: true,
    redirect: true,
    isSubRoute: true,
    configName: "COMMERCIAL_EVALUATION",
  },
  {
    component: InitiateEvaluation,
    path: "/Buyer-Bidding-Initiate-Evaluation",
    name: "Initiate Evaluation",
    icon: "fas fa-tachometer-alt",
    miniName: "V",
    layout: "/admin",
    isSidebar: true,
    redirect: true,
    isSubRoute: true,
    configName: "InitiateEvaluation",
  },
  {
    component: ComparisonroundoneCommercial,
    path: "/Buyer-Bidding-Commercial-Comparision-Round-1/:id",
    name: "Commercial Comparison Round 1",
    icon: "fas fa-tachometer-alt",
    miniName: "V",
    layout: "/admin",
    isSidebar: true,
    redirect: true,
    isSubRoute: true,
    configName: "COMMERCIAL_EVALUATION",
  },
  {
    component: CommercialComparison,
    path: "/Buyer-Bidding-Commercial-Comparison/:id",
    name: "Commercial Comparison",
    icon: "fas fa-tachometer-alt",
    miniName: "V",
    layout: "/admin",
    isSidebar: true,
    redirect: true,
    isSubRoute: true,
    configName: "COMMERCIAL_EVALUATION",
  },
  {
    component: Profile,
    path: "/profile/:id",
    name: "Profile",
    icon: "fas fa-tachometer-alt",
    miniName: "P",
    layout: "/admin",
    isSidebar: true,
    redirect: true,
    isSubRoute: true,
    configName: "VIEW_PROFILE",
  },
  {
    path: "/po-detail-supply",
    name: "PO Detail",
    icon: "fas fa-tachometer-alt",
    miniName: "P",
    component: PoDetail,
    layout: "/admin",
    isSidebar: true,
    redirect: true,
    isSubRoute: true,
    configName: "PURCHASE_ORDER_LISTING",
  },
  {
    path: "/po-detail-services/:id",
    name: "PO Detail Service",
    icon: "fas fa-tachometer-alt",
    miniName: "P",
    component: PodetailService,
    layout: "/admin",
    isSidebar: true,
    redirect: true,
    isSubRoute: true,
    configName: "PURCHASE_ORDER_LISTING",
  },
  {
    path: "/asn-detail",
    name: "ASN Detail",
    icon: "fas fa-tachometer-alt",
    miniName: "A",
    component: AsnDetail,
    layout: "/admin",
    isSidebar: true,
    redirect: true,
    isSubRoute: true,
    configName: "ASN_LISTING",
  },
  {
    path: "/grn-deatil/:id",
    name: "GRN Detail",
    icon: "fas fa-tachometer-alt",
    miniName: "A",
    component: GrnDetail,
    layout: "/admin",
    isSidebar: true,
    redirect: true,
    isSubRoute: true,
    configName: "GRN_LISTING",
  },
  {
    path: "/qc-detail/:id",
    name: "QC Detail",
    icon: "fas fa-tachometer-alt",
    miniName: "Q",
    component: QcDetails,
    layout: "/admin",
    isSidebar: true,
    redirect: true,
    isSubRoute: true,
    configName: "QC_LISTING",
  },
  {
    path: "/qc-creation-form",
    name: "QC Creation Form",
    icon: "fas fa-tachometer-alt",
    miniName: "Q",
    component: QcCreationForm,
    layout: "/admin",
    isSidebar: true,
    redirect: true,
    isSubRoute: true,
    configName: "QC_LISTING",
  },


];

let routesArr = [];

for (let a = 0; a < loginPageRoutes.length; a++) {
  let isValid = false;

  if (loginPageRoutes[a].collapse == true) {
    let viewArr = [];
    for (let b = 0; b < loginPageRoutes[a].views.length; b++) {
      let isViewValid = false;
      if (loginPageRoutes[a].views[b].layout == "/admin") {
        for (let i = 0; i < modulePermissions.length; i++) {
          for (let j = 0; j < modulePermissions[i]?.subModules.length; j++) {
            for (
              let k = 0;
              k < modulePermissions[i]?.subModules[j]?.features.length;
              k++
            ) {
              if (
                modulePermissions[i]?.subModules[j]?.features[k]?.uniqueName ==
                loginPageRoutes[a].views[b]?.configName &&
                modulePermissions[i]?.subModules[j]?.features[k]?.permissions
                  ?.read == true
              ) {
                isViewValid = true;
              }
            }
          }
        }
      }
      if (isViewValid) {
        viewArr.push(loginPageRoutes[a].views[b]);
      }
    }
    loginPageRoutes[a].views = [...viewArr];
    isValid = true;
  } else {
    if (loginPageRoutes[a].layout == "/admin") {
      for (let i = 0; i < modulePermissions.length; i++) {
        for (let j = 0; j < modulePermissions[i]?.subModules.length; j++) {
          for (
            let k = 0;
            k < modulePermissions[i]?.subModules[j]?.features.length;
            k++
          ) {

            if (modulePermissions[i]?.subModules[j]?.features[k]?.uniqueName == loginPageRoutes[a]?.configName && modulePermissions[i]?.subModules[j]?.features[k]?.permissions?.read == true) {
              isValid = true;
            }
          }
        }
      }
    }
  }

  if (isValid == true) {
    routesArr.push(loginPageRoutes[a]);
  }
}
const routes = [...authLoginArr, ...routesArr];

export default routes;
